import React from "react";
import { Platform } from "react-native";
import { renderToStaticMarkup } from "react-dom/server";
import { Svg as NativeSvg, SvgXml, } from "react-native-svg";
export const Svg = ({ children, ...props }) => {
    if (Platform.OS === "web") {
        return (React.createElement(NativeSvg, { tabIndex: -1, ...props }, children));
    }
    return (React.createElement(SvgXml, { xml: renderToStaticMarkup(React.createElement("svg", null, children)), ...props }));
};
//# sourceMappingURL=Svg.js.map